<div class="preopen-accordion">
    <div class="accordion-header">
        <h4 class="accordion-title">{{ header | translate }}</h4>
        <div class="action-wrapper">
            <ng-content select="[accordionActions]"></ng-content>
            <button
                *ngIf="hasOverflow"
                class="toggle-button"
                [ngClass]="{ 'use-modus-icons': useModusIcons }"
                (click)="toggleExpand()"
            >
                <ng-container *ngIf="!useModusIcons">
                    {{ toggleLabel | translate }}
                </ng-container>
                <ng-container *ngIf="useModusIcons">
                    <i *ngIf="isExpanded" class="modus-icons">expand_less</i>
                    <i *ngIf="!isExpanded" class="modus-icons">expand_more</i>
                </ng-container>
            </button>
        </div>
    </div>
    <div
        #accordionContent
        class="accordion-content"
        [style.maxHeight]="contentMaxHeight"
        [class.collapsed]="!isExpanded && hasOverflow"
    >
        <ng-content></ng-content>
    </div>
</div>
